import { bHas } from "../../utils/bit.js";
//#region ../erd-editor-schema/dist/v3/schema/settings.js
var NameViewMode = {
	physical: "physical",
	logical: "logical",
	both: "both"
};
var NameViewModeList = Object.values(NameViewMode);
var DDLScriptPosition = {
	before: "before",
	after: "after"
};
var DDLScriptPositionList = Object.values(DDLScriptPosition);
var CanvasType = {
	ERD: "ERD",
	visualization: "@dineug/erd-editor/builtin-visualization",
	schemaSQL: "@dineug/erd-editor/builtin-schema-sql",
	generatorCode: "@dineug/erd-editor/builtin-generator-code",
	settings: "settings",
	dictionary: "@dineug/erd-editor/builtin-dictionary"
};
var CanvasTypeList = Object.values(CanvasType);
var Show = {
	tableComment: 1,
	columnComment: 2,
	columnDataType: 4,
	columnDefault: 8,
	columnAutoIncrement: 16,
	columnPrimaryKey: 32,
	columnUnique: 64,
	columnNotNull: 128,
	relationship: 256,
	columnAlternateKey: 512,
	hideReferentialAction: 1024,
	hideTableGroup: 2048,
	hideMemo: 4096,
	columnDomain: 8192
};
var ColumnType = {
	columnName: 1,
	columnDataType: 2,
	columnNotNull: 4,
	columnUnique: 8,
	columnAutoIncrement: 16,
	columnDefault: 32,
	columnComment: 64,
	columnLogicalName: 128,
	columnDomain: 256
};
var ColumnTypeList = Object.values(ColumnType);
var Database = {
	MariaDB: 1,
	MSSQL: 2,
	MySQL: 4,
	Oracle: 8,
	PostgreSQL: 16,
	SQLite: 32,
	Databricks: 64,
	Snowflake: 128
};
var DatabaseList = Object.values(Database);
var Language = {
	GraphQL: 1,
	csharp: 2,
	Java: 4,
	Kotlin: 8,
	TypeScript: 16,
	JPA: 32,
	Scala: 64,
	Go: 128,
	SQLAlchemy: 256,
	TypeORM: 512,
	Sequelize: 1024,
	Drizzle: 2048,
	DBML: 4096,
	AML: 8192,
	Mermaid: 16384,
	PHP: 32768,
	Doctrine: 65536,
	Rust: 131072,
	SeaORM: 262144,
	Swift: 524288,
	Zod: 1048576,
	JSONSchema: 2097152
};
var LanguageList = Object.values(Language);
var NameCase = {
	none: 1,
	camelCase: 2,
	pascalCase: 4,
	snakeCase: 8
};
var NameCaseList = Object.values(NameCase);
var BracketType = {
	none: 1,
	doubleQuote: 2,
	singleQuote: 4,
	backtick: 8
};
var BracketTypeList = Object.values(BracketType);
var LockSettingType = {
	viewport: 1,
	canvasType: 2,
	language: 4,
	tableNameCase: 8,
	columnNameCase: 16,
	bracketType: 32,
	unlockNameViewMode: 64
};
var LockSettingTypeList = Object.values(LockSettingType);
var InvertedLockSettings = LockSettingType.unlockNameViewMode;
var LockSettingFields = {
	[LockSettingType.viewport]: [
		"originX",
		"originY",
		"zoomLevel"
	],
	[LockSettingType.canvasType]: ["canvasType"],
	[LockSettingType.language]: ["language"],
	[LockSettingType.tableNameCase]: ["tableNameCase"],
	[LockSettingType.columnNameCase]: ["columnNameCase"],
	[LockSettingType.bracketType]: ["bracketType"],
	[LockSettingType.unlockNameViewMode]: ["nameViewMode"]
};
var assertSingleBit = (bit) => {
	if (!Number.isInteger(bit) || bit <= 0 || (bit & bit - 1) !== 0) throw new RangeError(`A lock is one bit, not ${bit}`);
};
function isSettingLocked(lockSettings, bit) {
	assertSingleBit(bit);
	return bHas(lockSettings, bit) !== bHas(InvertedLockSettings, bit);
}
function setSettingLock(lockSettings, bit, locked) {
	assertSingleBit(bit);
	return locked !== bHas(InvertedLockSettings, bit) ? lockSettings | bit : lockSettings & ~bit;
}
var CANVAS_ZOOM_MIN = .1;
var CANVAS_ZOOM_MAX = 1.5;
var CANVAS_SIZE_MIN = 2e3;
var CANVAS_SIZE_MAX = 2e4;
//#endregion
export { BracketType, BracketTypeList, CANVAS_SIZE_MAX, CANVAS_SIZE_MIN, CANVAS_ZOOM_MAX, CANVAS_ZOOM_MIN, CanvasType, CanvasTypeList, ColumnType, ColumnTypeList, DDLScriptPosition, DDLScriptPositionList, Database, DatabaseList, InvertedLockSettings, Language, LanguageList, LockSettingFields, LockSettingType, LockSettingTypeList, NameCase, NameCaseList, NameViewMode, NameViewModeList, Show, isSettingLocked, setSettingLock };
